import React, { useState } from "react";
import Header from "../components/layout/Header";
import LegalFooter from "../components/common/LegalFooter";
import ThankYouModal from "../components/common/ThankYouModal";
import styles from "./ContactUs.module.scss";

// ICONS
const MailIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347" />
  </svg>
);

const UserIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const MapPinIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const PhoneIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const LockIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const ShieldLineIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

const ChartLineIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
  </svg>
);

const HeadphoneIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
    <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
  </svg>
);

export default function ContactUs() {
  const [isThankYouModalOpen, setIsThankYouModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    city: ""
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    const newFormData = { ...formData };

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Full Name is required";
    } else if (!/^[a-zA-Z\s]+$/.test(formData.fullName)) {
      newErrors.fullName = "Please enter a valid name";
      newFormData.fullName = "";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email ID is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
      newFormData.email = "";
    }

    if (!formData.city.trim()) {
      newErrors.city = "City Name is required";
    } else if (!/^[a-zA-Z\s]+$/.test(formData.city)) {
      newErrors.city = "Please enter a valid city name";
      newFormData.city = "";
    }

    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = "Contact Number is required";
    } else if (!/^\d{10,15}$/.test(formData.phoneNumber.replace(/[\s-]/g, ''))) {
      newErrors.phoneNumber = "Please enter a valid 10-digit number";
      newFormData.phoneNumber = "";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setFormData(newFormData);
      return false;
    }
    return true;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "fullName" || name === "city") {
      if (!/^[a-zA-Z\s]*$/.test(value)) return;
    }
    if (name === "phoneNumber") {
      if (!/^\d*$/.test(value)) return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      setIsSubmitting(true);

      // Simulate network request delay for animation effect
      setTimeout(() => {
        setIsSubmitting(false);
        setIsThankYouModalOpen(true);
        setFormData({
          fullName: "",
          email: "",
          phoneNumber: "",
          city: ""
        });
      }, 1500);
    }
  };

  return (
    <div className={styles.pageWrapper}>
      <Header />

      <main className={styles.mainContent}>
        <div className={styles.container}>
          <div className={styles.contactLayout}>

            {/* LEFT SECTION */}
            <div className={styles.leftSection}>

              <div className={styles.introCard}>
                {/* <span className={styles.badge}>CONTACT US</span> */}

                <h1 className={styles.title}>
                  Contact <span>Us</span>
                </h1>

                <div className={styles.titleUnderline}></div>

                <p className={styles.intro}>
                  If you would like to connect with Munafa Engine,
                  share your details below and our team will take
                  the conversation forward.
                </p>

                <div className={styles.featuresRow}>
                  <div className={styles.featureItem}>
                    <div className={styles.featureIcon}><ShieldLineIcon /></div>
                    <p>Trusted by<br />Salon Owners</p>
                  </div>
                  <div className={styles.featureItem}>
                    <div className={styles.featureIcon}><ChartLineIcon /></div>
                    <p>Data-Backed<br />Guidance</p>
                  </div>
                  <div className={styles.featureItem}>
                    <div className={styles.featureIcon}><HeadphoneIcon /></div>
                    <p>Dedicated<br />Support</p>
                  </div>
                  <div className={styles.featureItem}>
                    <div className={styles.featureIcon}><LockIcon /></div>
                    <p>Your Data is<br />100% Secure</p>
                  </div>
                </div>
              </div>

              <div className={styles.imageCard}>
                <img
                  src={require("../images/Contact Us.webp")}
                  alt="Contact"
                  className={styles.heroImage}
                 loading="lazy" decoding="async"/>
              </div>

            </div>

            {/* RIGHT SECTION */}
            <div className={styles.rightSection}>

              <div className={styles.formCard}>
                <h2 className={styles.formTitle}>
                  Get in Touch
                </h2>

                <p className={styles.formSubTitle}>
                  Please fill in all the details below.
                </p>

                <div className={styles.mandatoryText}>
                  <LockIcon /> All fields are mandatory.
                </div>

                <form
                  className={styles.formGrid}
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <label className={`${styles.customInput} ${errors.fullName ? styles.hasError : ''}`}>
                    <div className={styles.inputIcon}><UserIcon /></div>
                    <div className={styles.inputTextWrapper}>
                      <span className={styles.inputLabel}>Full Name</span>
                      <input
                        type="text"
                        name="fullName"
                        placeholder={errors.fullName || "Enter your full name"}
                        className={styles.inputField}
                        value={formData.fullName}
                        onChange={handleChange}
                      />
                    </div>
                  </label>

                  <label className={`${styles.customInput} ${errors.email ? styles.hasError : ''}`}>
                    <div className={styles.inputIcon}><MailIcon /></div>
                    <div className={styles.inputTextWrapper}>
                      <span className={styles.inputLabel}>Email ID</span>
                      <input
                        type="email"
                        name="email"
                        placeholder={errors.email || "Enter your email ID"}
                        className={styles.inputField}
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                  </label>

                  <label className={`${styles.customInput} ${errors.city ? styles.hasError : ''}`}>
                    <div className={styles.inputIcon}><MapPinIcon /></div>
                    <div className={styles.inputTextWrapper}>
                      <span className={styles.inputLabel}>City Name</span>
                      <input
                        type="text"
                        name="city"
                        placeholder={errors.city || "Enter your city name"}
                        className={styles.inputField}
                        value={formData.city}
                        onChange={handleChange}
                      />
                    </div>
                  </label>

                  <label className={`${styles.customInput} ${errors.phoneNumber ? styles.hasError : ''}`}>
                    <div className={styles.inputIcon}><PhoneIcon /></div>
                    <div className={styles.inputTextWrapper}>
                      <span className={styles.inputLabel}>Contact Number</span>
                      <input
                        type="tel"
                        name="phoneNumber"
                        placeholder={errors.phoneNumber || "Enter your contact number"}
                        className={styles.inputField}
                        value={formData.phoneNumber}
                        onChange={handleChange}
                      />
                    </div>
                  </label>

                  <button
                    type="submit"
                    className={`${styles.submitButton} ${isSubmitting ? styles.isSubmitting : ''}`}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <div className={styles.spinner}></div>
                        Sending...
                      </>
                    ) : (
                      "Submit Request"
                    )}
                  </button>
                </form>
              </div>

              <div className={styles.directCard}>
                <h3>
                  Or, if you prefer to <span>connect</span> directly:
                </h3>

                <div className={styles.directItem}>
                  <div className={`${styles.directIcon} ${styles.bgOrange}`}><MailIcon /></div>
                  <p>Email: <span>connect@munafaengine.com</span></p>
                </div>

                <div className={styles.directItem}>
                  <div className={`${styles.directIcon} ${styles.bgGreen}`}><WhatsAppIcon /></div>
                  <p>WhatsApp: <a href="https://wa.me/15559303709?text=Hi%20Munafa%20Engine%2C%20I%20want%20to%20know%20more%20about%20weekly%20salon%20clarity." target="_blank" rel="noopener noreferrer">Chat on WhatsApp</a></p>
                </div>

                <div className={styles.directItem}>
                  <div className={`${styles.directIcon} ${styles.bgOrange}`}><ShieldLineIcon /></div>
                  <p>We will review your message and respond through the appropriate channel.</p>
                </div>
              </div>

            </div>

          </div>
        </div>
      </main>

      <LegalFooter />

      <ThankYouModal
        isOpen={isThankYouModalOpen}
        onClose={() => setIsThankYouModalOpen(false)}
      />
    </div>
  );
}